<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path class="bright" d="M11,3v2c0,0.55-0.45,1-1,1H3V4L0,6.5L3,9V7h7c1.1,0,2-0.9,2-2V3H11z" />
</svg>
</template>